import { type MenuItemType } from "owa-filterable-menu/lib/components/MenuItemType";
import { getMailMenuItemShouldHideForMailbox } from "owa-mail-filterable-menu-behavior";
import { tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault, type TableView, } from "owa-mail-list-store";
import getMailboxInfo from "owa-mail-mailboxinfo/lib/getMailboxInfo";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isNativeReportingEnabled } from "owa-reporting";
import doesFolderIdEqualName from "owa-session-store/lib/utils/doesFolderIdEqualName";

export default function shouldShowNotJunkHoverAction(tableView: TableView | undefined, rowKey: string): boolean {
    if (!isGlobalFeatureEnabled("tri-promote-not-junk") ||
        !tableView ||
        !doesFolderIdEqualName(tableView.tableQuery.folderId, "junkemail")) {
        return false;
    }
    
    const mailboxInfo = tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault(getMailboxInfo(tableView), [rowKey], tableView);
    
    return (isNativeReportingEnabled(mailboxInfo) &&
        !getMailMenuItemShouldHideForMailbox(22, mailboxInfo));
}
